<h1 class="save-line-head" i18n='@@title-PaymentMethods'>Metodi di pagamento</h1>

<div class="menu-row">
  @if (isPayPalActive) {
    <a routerLink="paypal" class="menu-link">
      <mat-card class="menu-card">
        <div class="menu-content">
          <mat-icon svgIcon="credit-card" class="start-icon"></mat-icon>
          <span class="label">PayPal</span>
          <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
        </div>
      </mat-card>
    </a>
  }

  @if (isIGFSActive) {
    <a routerLink="satispay" class="menu-link">
      <mat-card class="menu-card">
        <div class="menu-content">
          <mat-icon svgIcon="credit-card" class="start-icon"></mat-icon>
          <span class="label">Satispay</span>
          <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
        </div>
      </mat-card>
    </a>
  }
</div>

@if (!isPayPalActive && !isIGFSActive) {
  <div>
    <h3 i18n='@@nogateWay'>Nessun metodo di pagamento alternativo disponibile.</h3>
  </div>
}
